import React from 'react'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { breakpoints } from '~styles/global'
import Image from '~components/Image'
import Video from '~components/Video'

const DoubleImageBlock = ({ imageLeft, videoLeft, imageRight, videoRight, className }) => {

  const {mobile} = breakpoints 
    
  return (
    <div
      className={className}
        css={css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        ${mobile} {
            grid-template-columns: 1fr;
        }
    `}>
        { videoLeft ?
          (
            <Video src={videoLeft?.asset?.url} aspectRatio={1} css={css`
              width: 100%;
              height: 100%;
              object-fit: cover;
            `} />
          ):
          (
            <Image asset={imageLeft} aspectRatio={1} css={css`
              .gatsby-image-wrapper {
                height: 100%;
              }
            `}/>
          )
        }
        { videoRight ?
          (
            <Video src={videoRight?.asset?.url} aspectRatio={1} css={css`
              width: 100%;
              height: 100%;
              object-fit: cover;
            `} />
          ):
          (
            <Image asset={imageRight} aspectRatio={1} css={css`
              .gatsby-image-wrapper {
                height: 100%;
              }
            `}/>
          )
        }
    </div>
  )
}

DoubleImageBlock.propTypes = {
  imageLeft: PropTypes.object,
  imageRight: PropTypes.object,
  videoLeft: PropTypes.object,
  videoRight: PropTypes.object,
}

DoubleImageBlock.defaultProps = {
}

export default DoubleImageBlock
